import { render, staticRenderFns } from "./librosXinstitucion.vue?vue&type=template&id=101d1f92&scoped=true"
import script from "./librosXinstitucion.vue?vue&type=script&lang=js"
export * from "./librosXinstitucion.vue?vue&type=script&lang=js"
import style0 from "./librosXinstitucion.vue?vue&type=style&index=0&id=101d1f92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101d1f92",
  null
  
)

export default component.exports